const KEY = 'pos_verified_session_v1';
export function saveOfflineSession(tenant, user, stores, token) {
  if (tenant?.kind !== 'tenant' || !['admin', 'cashier'].includes(user?.role)) return;
  localStorage.setItem(KEY, JSON.stringify({ tenant, user, stores, token }));
}
export function readOfflineSession() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    const token = localStorage.getItem('pos_token');
    if (!value || !token || value.token !== token || value.tenant.kind !== 'tenant') return null;
    const claims = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!Number.isFinite(claims.exp) || claims.exp * 1000 <= Date.now() || claims.aud !== value.tenant.id || claims.sub !== value.user.id) return null;
    return value;
  } catch { return null; }
}
export const clearOfflineSession = () => localStorage.removeItem(KEY);
